import React from 'react';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';

import { getAuthTypeIcon } from './utils';

interface AuthTypeBadgeProps {
  label: string;
  icon: string;
}

export const AuthTypeBadge: React.FC<AuthTypeBadgeProps> = ({ label, icon }) => {
  const theme = useTheme();

  return (
    <Badge
      size="small"
      bgColor="white"
      borderColor={theme.token.colorBorderSecondary}
      label={
        <SmallText color={theme.token.colorPrimaryText} fontWeight={500} className="text-nowrap">
          {label}
        </SmallText>
      }
      icon={<FontAwesomeIcon icon={getAuthTypeIcon(icon)} color={theme.token.colorPrimaryBase} />}
    />
  );
};
